import React, { useState, useMemo, useRef } from 'react';
import ChartsIndex from '@/pages/intelligence/components/ChartsComponents/ChartsIndex';
import { ChartType } from '@/pages/intelligence/pages/TopCharts/_config/enums';
import { DATA_SOURCE_NAME_MAP } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { getPlatformName } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import useBarCharts from '@/pages/intelligence/components/Chart/hooks/useBarCharts';
import useLineCharts from '@/pages/intelligence/components/Chart/hooks/useLineCharts';
import { getCountryImg } from '@/pages/intelligence/utils/common';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';


//每个榜单，组装好各类可视化需要的数据，传递给可视化统一组件
const Visualis: React.FC<any> = (props: any) => {
  const {
    chartType = ChartType.Line,
    lineData = [], // 折线 数据
    isNodata,
  } = props;

  const { locale, formatMessage } = useIntlExtend();

  const [chartLoading, setChartLoading] = useState(false);

  //组装rpd折线图数据
  const getRpdTypeData = (list: any) => {
    if (!Array.isArray(list) || list?.length < 1) return [];
    let arr: any = [];
    for (let i in list) {
      arr.push({
        source: 'appannie',
        time: list[i].name,
        value: list[i].value,
      });
    }
    return arr;
  };

  const lineSeriesData = useMemo(() => {
    let arrGameData: any = [];
    for (let n in lineData) {
      const gameObj = lineData[n];
      const objTemp = {
        cover: 'Global',
        id: 'Global',
        name: formatMessage({ id: 'dbi_global', defaultMessage: 'Global' }),
        history: getRpdTypeData(gameObj.metrics),
      };
      arrGameData.push(objTemp);
    }
    const temp = {
      source: Array.isArray(arrGameData) ? arrGameData : [],
    };
    return temp;
  }, [locale, lineData]);

  // 获取折线图hooks
  const {
    lineOption
  } = useLineCharts({
    lineData: lineSeriesData,
    topChartsType: 'stats-retentionmonthly-trend',
    metric: 'source',
  });

  return (
    <>
      <div className="card-line">
        <ChartsIndex
          chartLoading={chartLoading}
          lineOption={lineOption}
          chartType={chartType}
          isNodata={isNodata}
        />
      </div>
    </>
  );
};

export default Visualis;
